// src/utils/filter-handler.js
function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
var ProductFilterForm = class extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.priceRangeValues = {};
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 1e3);
    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    window.addEventListener("popstate", this.onHistoryChange.bind(this));
    this.displayFilters();
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFilters();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
  onHistoryChange(event) {
    var _a;
    const searchParams = ((_a = event.state) == null ? void 0 : _a.searchParams) || "";
    this.renderPage(searchParams, null, false);
  }
  toggleActiveFilters(disable = true) {
    document.querySelectorAll(".js-filter-remove").forEach((element) => {
      element.classList.toggle("hidden", disable);
    });
    this.displayFilters();
  }
  renderPage(searchParams, event, updateURLHash = true) {
    const priceRangeSlider = document.querySelector("price-range-slider");
    if (priceRangeSlider) {
      this.priceRangeValues.min = priceRangeSlider.querySelector(".min-input").value;
      this.priceRangeValues.max = priceRangeSlider.querySelector(".max-input").value;
    }
    const sections = this.getSections();
    document.querySelector("[collection-loader]").classList.remove("invisible", "opacity-0");
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      this.filterData.some(filterDataUrl) ? this.renderSectionFromCache(filterDataUrl, event) : this.renderSectionFromFetch(url, event);
    });
    if (updateURLHash)
      this.updateURLHash(searchParams);
  }
  renderSectionFromFetch(url, event) {
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      this.filterData = [...this.filterData, { html, url }];
      this.renderFilters(html, event);
      this.renderProductGrid(html);
    }).then(() => {
      document.querySelector("[collection-loader]").classList.add("invisible", "opacity-0");
    });
  }
  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
    document.querySelector("[collection-loader]").classList.add("invisible", "opacity-0");
  }
  renderProductGrid(html) {
    document.querySelector("#main-collection-wrapper").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector("#main-collection-wrapper").innerHTML;
  }
  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const currentFilterOptionsMain = this.querySelector("[data-filter-main]");
    const renderedFilterOptionsMain = parsedHTML.querySelector("[data-filter-main]");
    currentFilterOptionsMain.innerHTML = renderedFilterOptionsMain.innerHTML;
    const priceRangeSlider = document.querySelector("price-range-slider");
    if (priceRangeSlider) {
      priceRangeSlider.querySelector(".min-input").value = this.priceRangeValues.min;
      priceRangeSlider.querySelector(".max-input").value = this.priceRangeValues.max;
      priceRangeSlider.querySelector(".min-range").value = this.priceRangeValues.min;
      priceRangeSlider.querySelector(".max-range").value = this.priceRangeValues.max;
      priceRangeSlider.updateVisuals();
    }
    this.renderActiveFilters(parsedHTML);
  }
  renderActiveFilters(html) {
    const activeFilterElementIdentifier = "[data-filter-current]";
    const currentActiveFiltersHeaderElement = document.querySelector(activeFilterElementIdentifier);
    const renderedActiveFilterElement = html.querySelector(activeFilterElementIdentifier);
    if (!renderedActiveFilterElement)
      return;
    currentActiveFiltersHeaderElement.outerHTML = renderedActiveFilterElement.outerHTML;
    this.displayFilters();
    this.toggleActiveFilters(false);
  }
  displayFilters() {
    const filterFormNets = document.querySelector("[data-filter-form-nets]");
    const activeFilters = document.querySelector("[data-filter-current] [data-filter-list]").children;
    const filterClearAll = document.querySelector("[data-filter-clear-all]");
    if (!filterFormNets) {
      if (activeFilters.length <= 0)
        filterClearAll.classList.add("hidden");
    } else {
      filterClearAll.classList.add("hidden");
    }
    const filterLists = document.querySelectorAll("[data-filter-list]");
    filterLists.forEach((list) => list.children.length === 0 ? list.closest(".js-filter").classList.add("hidden") : list.closest(".js-filter").classList.remove("hidden"));
  }
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }
  getSections() {
    return [
      {
        id: "main-collection",
        section: document.getElementById("main-collection").dataset.id
      }
    ];
  }
};
if (!customElements.get("product-filter-form")) {
  customElements.define("product-filter-form", ProductFilterForm);
}
var PriceRangeSlider = class extends HTMLElement {
  constructor() {
    super();
    this.minInput = this.querySelector(".min-input");
    this.maxInput = this.querySelector(".max-input");
    this.minRange = this.querySelector(".min-range");
    this.maxRange = this.querySelector(".max-range");
    this.rangeFill = this.querySelector(".range-slider .range");
    this.initializeFromDataAttributes();
    [this.minInput, this.maxInput, this.minRange, this.maxRange].forEach((input) => {
      input.addEventListener("input", this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
    this.updateVisuals();
  }
  initializeFromDataAttributes() {
    this.minInput.value = this.minInput.getAttribute("data-attribute-custom-value") || 0;
    this.maxInput.value = this.maxInput.getAttribute("data-attribute-custom-value") || 100;
    this.minRange.value = this.minRange.getAttribute("data-attribute-custom-value") || 0;
    this.maxRange.value = this.maxRange.getAttribute("data-attribute-custom-value") || 100;
  }
  onRangeChange(event) {
    const input = event.currentTarget;
    this.adjustToValidValues(input);
    this.updateVisuals();
  }
  adjustToValidValues(input) {
    const minValue = Number(this.minInput.value);
    const maxValue = Number(this.maxInput.value);
    if (input === this.minInput || input === this.minRange) {
      if (Number(input.value) > maxValue) {
        input.value = maxValue;
      }
      this.minInput.value = this.minRange.value = input.value;
    } else if (input === this.maxInput || input === this.maxRange) {
      if (Number(input.value) < minValue) {
        input.value = minValue;
      }
      this.maxInput.value = this.maxRange.value = input.value;
    }
    this.updateValueAttributes();
    this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const minValue = Number(this.minInput.value);
    const maxValue = Number(this.maxInput.value);
    this.minRange.setAttribute("max", maxValue);
    this.maxRange.setAttribute("min", minValue);
  }
  updateValueAttributes() {
    this.minInput.setAttribute("data-attribute-custom-value", this.minInput.value);
    this.maxInput.setAttribute("data-attribute-custom-value", this.maxInput.value);
    this.minRange.setAttribute("data-attribute-custom-value", this.minRange.value);
    this.maxRange.setAttribute("data-attribute-custom-value", this.maxRange.value);
    this.minInput.setAttribute("value", this.minInput.value);
    this.maxInput.setAttribute("value", this.maxInput.value);
    this.minRange.setAttribute("value", this.minRange.value);
    this.maxRange.setAttribute("value", this.maxRange.value);
  }
  updateVisuals() {
    const minPercent = (this.minRange.value - this.minRange.min) / (this.minRange.max - this.minRange.min) * 100;
    const maxPercent = (this.maxRange.value - this.minRange.min) / (this.maxRange.max - this.minRange.min) * 100;
    this.rangeFill.style.left = `${minPercent}%`;
    this.rangeFill.style.width = `${maxPercent - minPercent}%`;
  }
};
if (!customElements.get("price-range-slider")) {
  customElements.define("price-range-slider", PriceRangeSlider);
}
var OptionRemove = class extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = this.closest("product-filter-form") || document.querySelector("product-filter-form");
      form.onActiveFilterClick(event);
    });
  }
};
if (!customElements.get("filter-remove")) {
  customElements.define("filter-remove", OptionRemove);
}
